import AnatomyV2RateYourself from '~/pages/anatomyV2/rateYourself/libs/components/AnatomyV2RateYourself'
import { TPageProps } from '~/shared/types/commonTypes'

const RateYourselfAnatomyV2 = (props: TPageProps) => (
  <AnatomyV2RateYourself {...props} />
)

export default RateYourselfAnatomyV2
